import { render, staticRenderFns } from "./ResourceTab.vue?vue&type=template&id=c6a13ef0"
import script from "./ResourceTab.vue?vue&type=script&lang=js"
export * from "./ResourceTab.vue?vue&type=script&lang=js"
import style0 from "./ResourceTab.vue?vue&type=style&index=0&id=c6a13ef0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports